const actions = {
  /**
   * Fetch the purchases list.
   *
   * @param commit
   * @param $http
   * @param page
   * @returns {Promise<void>}
   */
  async fetchPurchasesList({ commit, rootState: { $http } }, { page }) {
    const { data } = await $http.get('/payment/historical', { params: { page } });

    commit('setPurchases', data);
  },

  /**
   * Fetch the uses list.
   *
   * @param commit
   * @param $http
   * @param page
   * @param filters
   * @returns {Promise<void>}
   */
  async fetchUsesList({ commit, rootState: { $http } }, { page, filters }) {
    const { data } = await $http.get('/user/credits', { params: { page, ...filters } });

    commit('setUses', data);
  },
};

export default actions;
